import { useEffect, useState } from "react";
import SkeletonList from "../common/SkeletonList";

const getCookie = (name) => {
    const match = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([.$?*|{}()\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)"));
    return match ? decodeURIComponent(match[1]) : null;
};

const buildImageUrl = (path) => {
    if (!path) return "./chatscreen/profile.svg";
    if (path.startsWith("http://") || path.startsWith("https://")) return path;
    if (path.startsWith("/")) return `${process.env.REACT_APP_API_BASE_URL}${path}`;
    return path;
};

export default function Contactmodel ({ isOpen, onClose, contact, type = "contacts" }) {
        const [items, setItems] = useState([]);
        const [loading, setLoading] = useState(false);
        const [error, setError] = useState("");
        const token = getCookie("admin_token");

        useEffect(() => {
            const fetchItems = async () => {
                if (!isOpen || !contact?.id || !token) return;
                setLoading(true);
                setError("");
                try {
                    const body = new URLSearchParams();
                    body.append("user_id", contact.id);
                    const endpoint = type === "mutual" ? 
                        `${process.env.REACT_APP_API_BASE_URL}/admin/connect/user/mutual` :
                        `${process.env.REACT_APP_API_BASE_URL}/admin/connect/user/contacts`;
                    const res = await fetch(endpoint, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded",
                            Authorization: `Bearer ${token}`,
                        },
                        body: body.toString(),
                    });
                    if (!res.ok) throw new Error("Failed to load list");
                    const json = await res.json();
                    const apiItems = json?.data?.[0]?.items || [];
                    const mapped = apiItems.map((i, idx) => ({
                        id: idx,
                        name: i.full_name || `${i.first_name || ""} ${i.last_name || ""}`.trim(),
                        phone: (i.country_code || "") + (i.phone_number || ""),
                        avatar: buildImageUrl(i.profile_image_url),
                    }));
                    setItems(mapped);
                } catch (e) {
                    setError(e.message || "Failed to load list");
                    setItems([]);
                } finally {
                    setLoading(false);
                }
            };
            fetchItems();
        }, [isOpen, contact?.id, type, token]);

        if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-3xl shadow-2xl w-full max-w-sm">
                {/* Header */}
                <div className="p-6 pb-4">
                    <div className="flex justify-between items-center mb-4">
                        <h2 className="text-lg font-bold text-gray-900">{type === "mutual" ? "Mutual Contacts" : "Total Contacts Uploaded"}</h2>
                        <button
                            onClick={onClose}
                            className="text-gray-500 hover:text-gray-700 p-1"
                        >
                            <img src='../admin/chatbar/close.svg' alt="close" className="w-5 h-5" />
                        </button>
                    </div>
                    {/* Search Bar */}
                    <div className="relative">
                        <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
                            <img src='../admin/chatbar/magnifer.svg' alt="search" className="w-4 h-4" />
                        </div>
                        <input
                            id="search"
                            type="search"
                            placeholder="Search"
                            className="w-full rounded-xl border border-gray-300 bg-white pl-10 pr-8 py-2 text-sm placeholder:text-gray-400 outline-none focus:border-[#7C4DFF]"
                        />
                    </div>
                </div>

                {/* Contacts List */}
                <div className="px-4 pb-4 max-h-64 overflow-y-auto [&::-webkit-scrollbar]:w-1 [&::-webkit-scrollbar-track]:mb-10  [&::-webkit-scrollbar-thumb]:bg-gray-400 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-track]:bg-gray-100">
                    <div className="space-y-2">
                        {loading && <SkeletonList count={6} compact={true} />}
                        {error && !loading && <p className="text-sm text-red-500 px-2">{error}</p>}
                        {!loading && !error && items.map((c) => (
                          <button
                              key={c.id}
                              className="flex items-center gap-3 p-3 rounded-[100px] border border-gray-100 shadow-xl cursor-pointer transition-all duration-200 bg-[#797C7B] bg-opacity-[11%]   w-full"
                          >
                              <img
                                  src={c.avatar}
                                  alt={c.name}
                                  className="h-10 w-10 rounded-full object-cover"
                              />
                              <div className="text-left">
                                  <p className="font-medium text-gray-900 text-sm">{c.name}</p>
                                  <p className="text-xs text-gray-500">{c.phone}</p>
                              </div>
                          </button>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
